import styled from 'styled-components'

export const ButtonsBlock = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  padding: 0 52px;
  width: 100%;
  @media (min-width: 576px) {
    padding: 0 85px;
  }
`

export const WrapperForH4 = styled.div`
  color: #646877;
  font-weight: 400;
`

export const WrapperForH3 = styled.div`
  font-size: 14px;
  margin-bottom: 10px;
`

export const WrapperSearchContainer = styled.div`
  .form__form-group-error {
    top: -29px;
    right: 2px;
  }
`

export const ModalHeaderPromocode = styled.div`
  line-height: 27px;
  color: #646877;
  font-weight: 400;
  font-size: 18px;
`

export const ModalSubHeaderPromocode = styled.div`
  line-height: 21px;
  color: #646877;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 16px;
`

export const ErrorText = styled.div`
  color: #ec5765;
  line-height: 21px;
  margin-top: -32px;
  margin-bottom: 40px;
  @media (min-width: 576px) {
    margin-top: -32px;
    margin-bottom: 40px;
  }
`
export const FormGroup = styled.div`
  padding: 0 24px;
`
